import { useEffect, useMemo } from 'react';
import { useCodingEnabled } from '~/hooks/queries/use-tenant';
import { useProBuilderEnabled } from '~/hooks/queries/use-feature-flags';
import { useChatActivity } from '~/features/chat/top-bar/use-chat-activity';
import { useAttentionStore } from '~/lib/stores/attention-store';

/**
 * The chats, builds and Pro Builder session waiting on the person's answer —
 * the same data as the activity board's "Asking you" group (`useChatActivity`,
 * with builds and Pro Builder folded in exactly as the top bar does).
 *
 * It publishes the count to the attention store, which the app shell reads
 * for the browser tab's "(N)" prefix and favicon. The sidebar is mounted on
 * every page, so it is the publisher.
 */
export function useSidebarAsking(): void {
  const codingEnabled = useCodingEnabled();
  const proBuilderEnabled = useProBuilderEnabled();
  const { barChats } = useChatActivity({ includeBuilds: codingEnabled, includeProBuilder: proBuilderEnabled });
  const asking = useMemo(() => barChats.filter((c) => c.state === 'asking'), [barChats]);
  const setAsking = useAttentionStore((s) => s.setAsking);
  useEffect(() => {
    setAsking(asking.length);
  }, [asking.length, setAsking]);
  useEffect(() => () => setAsking(0), [setAsking]);
}
